"use client";

import { useEffect, useRef, useState } from "react";

const REVIEWS = [
  {
    name: "Sherin Kumar",
    review: "I had a great experience at Skinsio Clinic. The treatment helped reduce my acne and improved my skin texture. The staff was professional and the results are amazing. 🥰",
    rating: 5,
    treatment: "Acne Treatment",
  },
  {
    name: "Dr. Binita",
    review: "Doctors are really good, taking full care of the patient without pain, and very aesthetic way, thanks.",
    rating: 5,
    treatment: "",
  },
  {
    name: "Nandini Tiwari",
    review: "The clinic gotta be handsdown one of the best clinic in the area. The doctor is so chill and friendly. They will help you out in all the possible ways, whatever you will ask them, they make sure to clear your doubts. Plus it's so much affordable — they be giving all the services on an affordable price. 10/10 recommendations!",
    rating: 5,
    treatment: "",
  },
  {
    name: "Annie Khunt",
    review: "The clinic provided an exceptional experience. The service and staff were excellent — friendly, attentive, and supportive. They made sure I felt comfortable and well-cared for throughout my visit. I'm very happy with the results of my laser hair removal sessions. Dr. Akshay and Dr. Kanchan are very kind, gentle, and highly skilled. Highly recommended!",
    rating: 5,
    treatment: "Laser Hair Removal",
  },
  {
    name: "Chaitali Trivedi",
    review: "I had an absolutely wonderful experience at Skinsio Clinic. The doctor demonstrated exceptional professionalism, empathy, and expertise. He guided me through a moment of panic before the mole surgery, which made a world of difference. The procedure was conducted with remarkable smoothness and precision. The supporting staff are extremely kind, helpful, and supportive. I am highly satisfied with the results.",
    rating: 5,
    treatment: "Mole Removal",
  },
  {
    name: "Anjali Idnani",
    review: "Dr. Akshay is genuinely interested in the patient's wellbeing and not just there to earn money. He advises as per our concerns keeping in mind what works for us. I had my big day coming up and he made sure I looked perfect and advised me for after care accordingly. I was looking beautiful.",
    rating: 5,
    treatment: "Bridal Skincare",
  },
  {
    name: "Mansi Desai",
    review: "✨ I've been coming here for my laser hair removal sessions and I honestly couldn't be happier! Dr. Akshay and Dr. Kanchan are super nice, gentle, and highly skilled. My acne has improved so much — it's almost gone now, and my skin feels healthier than ever. 🌸 This clinic has truly been a blessing for me. 100% worth it! 🌟",
    rating: 5,
    treatment: "Laser Hair Removal & Acne",
  },
  {
    name: "Vinadevi Pathak",
    review: "SkinSio Clinic in Vadodara is the best treatment for the skin. I have visited many skin specialists in Ahmedabad and Surat but got satisfying treatment in said clinic. Dr. Akshay is treating me since last 4 months and I found miracle changes in my face and skin. Heartily thanks 🙏 to Dr. Akshay and SkinSio Clinic team.",
    rating: 5,
    treatment: "",
  },
  {
    name: "Bharti Sisodiya",
    review: "I have explored many clinics for laser hair removal and finally gone with SkinSio. Dr. Akshay Patil and Dr. Kanchan Patil both are very friendly and experienced. The clinic is very neat and clean. I have taken my 5 sessions and seen the results. Now I feel free from unwanted hair growth. Extremely happy and highly recommended! ✨",
    rating: 5,
    treatment: "Laser Hair Removal",
  },
  {
    name: "Herick Patel",
    review: "I had a fantastic experience at Skinsio clinic! The results have been beyond my expectations, and the pricing is super reasonable for the quality of service. The staff is warm, knowledgeable, and makes you feel at ease. My skin has improved so much — I highly recommend this clinic to anyone looking for effective and affordable skincare!",
    rating: 5,
    treatment: "",
  },
  {
    name: "Hinal Patil",
    review: "I am incredibly pleased with the results and guidance I received at SkinSio Vadodara Clinic. I underwent treatment for acne, scars, and LHR, and the transformation has been remarkable! The guidance provided by the doctors, from the initial consultation to the follow-up care, has been exceptional. Highly recommend SkinSio Vadodara for advanced skincare solutions!",
    rating: 5,
    treatment: "Acne, Scars & LHR",
  },
  {
    name: "Priyanka Panchal",
    review: "I had a fantastic experience with laser hair removal at this clinic. Doctors are professional, knowledgeable, and made me feel comfortable throughout the process. The procedure was quick, and the results have been excellent. Highly recommend them for outstanding care and results!",
    rating: 5,
    treatment: "Laser Hair Removal",
  },
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <svg key={i} className="w-4 h-4 text-golden fill-golden" viewBox="0 0 20 20">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
      ))}
    </div>
  );
}

function ReviewCard({ name, review, rating, treatment }: typeof REVIEWS[0]) {
  const [expanded, setExpanded] = useState(false);
  const isLong = review.length > 160;

  const initials = name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <div
      className="flex-shrink-0 w-80 bg-card border border-rose/15 rounded-2xl p-5 shadow-sm mx-3 flex flex-col gap-3 cursor-pointer transition-shadow hover:shadow-md hover:border-rose/30 relative overflow-hidden"
      onClick={() => isLong && setExpanded((e) => !e)}
    >
      {/* Top accent stripe — rose to gold gradient */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-rose to-golden" />

      {/* Stars + Google badge */}
      <div className="flex items-center justify-between pt-1">
        <StarRating count={rating} />
        <div className="flex items-center gap-1">
          <svg className="w-4 h-4" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          <span className="text-xs text-muted-foreground font-medium">Google</span>
        </div>
      </div>

      {/* Review text */}
      <p className="text-sm text-muted-foreground leading-relaxed">
        "{expanded ? review : isLong ? review.slice(0, 160) + "…" : review}"
      </p>

      {/* Read more / less toggle */}
      {isLong && (
        <button
          className="text-xs text-rose font-semibold text-left hover:underline w-fit"
          onClick={(e) => { e.stopPropagation(); setExpanded((v) => !v); }}
        >
          {expanded ? "Read less ↑" : "Read more ↓"}
        </button>
      )}

      {/* Author */}
      <div className="flex items-center gap-3 mt-auto pt-2 border-t border-border">
        <div className="w-9 h-9 rounded-full bg-gradient-to-br from-rose/20 to-golden/20 text-rose flex items-center justify-center text-xs font-bold flex-shrink-0">
          {initials}
        </div>
        <div>
          <p className="text-sm font-semibold">{name}</p>
          {treatment && (
            <p className="text-xs text-muted-foreground">{treatment}</p>
          )}
        </div>
      </div>
    </div>
  );
}

export function Reviews() {
  const trackRef = useRef<HTMLDivElement>(null);
  const isPausedRef = useRef(false);

  const allReviews = [...REVIEWS, ...REVIEWS];

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let animationId: number;
    let position = 0;
    const speed = 0.4;
    const singleSetWidth = track.scrollWidth / 2;

    const animate = () => {
      if (!isPausedRef.current) {
        position += speed;
        if (position >= singleSetWidth) position = 0;
        track.style.transform = `translateX(-${position}px)`;
      }
      animationId = requestAnimationFrame(animate);
    };

    animationId = requestAnimationFrame(animate);

    const pause = () => { isPausedRef.current = true; };
    const resume = () => { isPausedRef.current = false; };

    track.addEventListener("mouseenter", pause);
    track.addEventListener("mouseleave", resume);

    return () => {
      cancelAnimationFrame(animationId);
      track.removeEventListener("mouseenter", pause);
      track.removeEventListener("mouseleave", resume);
    };
  }, []);

  return (
    <section className="py-16 overflow-hidden aesthetic-gradient">
      {/* Header */}
      <div className="max-w-4xl mx-auto px-4 text-center mb-10">
        <p className="text-sm font-semibold text-rose uppercase tracking-widest mb-2">
          Patient Stories
        </p>
        <h2 className="text-3xl md:text-4xl font-bold mb-3">
          What Our Patients Say
        </h2>
        <p className="text-muted-foreground">
          Real reviews from real patients — 2200+ happy patients and counting.
        </p>
        <div className="flex items-center justify-center gap-2 mt-4">
          <StarRating count={5} />
          <span className="text-sm font-semibold">5.0</span>
          <span className="text-sm text-muted-foreground">· Based on Google Reviews</span>
        </div>
      </div>

      {/* Scrolling track */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />
        <div ref={trackRef} className="flex will-change-transform">
          {allReviews.map((review, index) => (
            <ReviewCard key={index} {...review} />
          ))}
        </div>
      </div>

      {/* Google CTA */}
      <div className="text-center mt-8">
        <a
          href="https://www.google.com/maps/search/?api=1&query=SkinSio+Vadodara"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm text-rose font-semibold hover:underline"
        >
          <svg className="w-4 h-4" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
          </svg>
          See all reviews on Google
        </a>
      </div>
    </section>
  );
}
